import Modal from "../../common/Modal";
import React from "react";
import {deletePic} from "../../../api/apiPic";

export const PicDeleteModal = (props) => {

    const {selectedData, setShowDeletePicModal, successCallback, errorCallback, isScheduled,
        selectedDataType, setSelectedDataType} = props;

    const defineDataType = () => {
        switch (selectedDataType) {
            case 'template': return 'Template';
            case 'project': return 'Projet';
            default: return 'PIC';
        }
    }

    /* Delete pic */
    const handleDelete = async (pic) => {
        setShowDeletePicModal(false);
        setSelectedDataType(null);

        await deletePic(pic.original_pic ? pic.original_pic.id : pic.id)
            .then(() => successCallback('Le PIC a été supprimé.'))
            .catch(() => errorCallback('Une erreur est survenue.'));
    };

    return(
        <Modal
            title={"Supprimer un " + defineDataType()}
            description={
                (isScheduled(selectedData.id) ?
                    `Votre " ${defineDataType()}" "${selectedData.name}" est actuellement planifié dans votre planning de production.\n` : '')
                + `Etes-vous sûr de vouloir supprimer "${selectedData.name}" ?`}
            cancelCallback={() => {
                setSelectedDataType(null);
                setShowDeletePicModal(false);
            }}
            buttons={[
                {label: `Oui, supprimer ${selectedData.name}`, callback: () => handleDelete(selectedData)}
            ]}
        />
    );
}
